import styles from "assets/styles.module.css";
import { DrawerContext } from "context/DrawerContext";
import useGetAssurance from "hooks/useGetAssurance";
import useGetParent from "hooks/useGetParent";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getParentForm } from "redux_dir/features/parentSlice";
import { ArrowLeft, Menu2 } from "tabler-icons-react";
import Credit from "./Credit";

function PageHeader({ title, path, canShow = true }) {
  const navigation = useNavigate();
  const { handleOpen } = React.useContext(DrawerContext);
  const user = useGetParent();
  const parent = useSelector(getParentForm);
  const app = useGetAssurance();

  // Déterminer l'environnement actuel
  const [currentEnv, setCurrentEnv] = useState("");

  useEffect(() => {
    // Détecter l'environnement en se basant sur l'URL de l'API
    const apiUrl = process.env.REACT_APP_BASE_API_URL || "";
    console.log("API URL détectée:", apiUrl);

    if (apiUrl.includes("recette-backend.genimi.io")) {
      console.log("Environnement détecté: RECETTE");
      setCurrentEnv("recette");
    } else if (apiUrl.includes("backend.genimi.io")) {
      console.log("Environnement détecté: PRODUCTION");
      setCurrentEnv("prod");
    } else {
      console.log("Environnement détecté: DÉVELOPPEMENT");
      setCurrentEnv("dev");
    }
  }, []);

  // Définir les couleurs selon l'environnement
  const getEnvironmentColor = () => {
    console.log("Environnement actuel:", currentEnv);

    switch (currentEnv) {
      case "recette":
        return "#00A86B"; // Vert pour recette
      case "prod":
        return "#2A65E5"; // Bleu pour production
      default:
        return "#3F51B5"; // Couleur par défaut pour dev
    }
  };

  // Définir le style du header
  const headerStyle = {
    backgroundColor:
      currentEnv === "recette" ? getEnvironmentColor() : "#2A65E5",
  };

  return (
    <div className={styles.pageHeader} style={headerStyle}>
      <ArrowLeft
        style={{
          cursor: "pointer",
        }}
        size={29}
        onClick={() => navigation(path ?? -1)}
      />
      {parent?.type === "CONFIRMED" ? (
        <h3 className="text-md font-bold max-sm:text-sm">{user?.fullName}</h3>
      ) : canShow ? (
        <h3 className="text-md font-bold max-sm:text-sm">
          {"Freemium (" + user?.fullName + ")"}
        </h3>
      ) : (
        <h3 className="text-md font-bold max-sm:text-sm">
          {title ?? "Freemium (" + user?.fullName + ")"}
        </h3>
      )}

      {canShow ? (
        <div className="flex items-center gap-2">
          {app === "Senassurance" && parent?.type === "CONFIRMED" ? null : (
            <Credit />
          )}
          <div
            className="p-2 cursor-pointer hover:text-[#999]"
            onClick={handleOpen}
          >
            <Menu2 />
          </div>
        </div>
      ) : (
        <div className=""></div>
      )}
    </div>
  );
}

export default PageHeader;
